<div id="sh-maintenance-container-div" *transloco="let t">
	<img src="assets/images/auto_room_blue_maintenance.svg" alt="maintenance" id="sh-maintenance-logo-img" />
	<div id="sh-maintenance-text-container-div">
		<h1 id="sh-maintenance-heading-h1">{{ t('cloud.shared.maintenance.we-will-be-back-soon') }}</h1>
		<p class="sh-maintenance-text" id="sh-maintenance-text-p">
			{{ t('cloud.shared.maintenance.inconvenience-maintenance-text') }}
		</p>
		<p class="sh-maintenance-text" id="sh-maintenance-date-p">
			{{
				'cloud.shared.maintenance.maintenance-mode-text' | transloco: { startDate: startAt(), endDate: endAt() }
			}}
		</p>
	</div>
</div>
